"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { pageTranslations, TLanguages } from "@/i18n/i18n";
import { cn } from "@/lib/utils";
import { SearchIcon } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function SearchBar({
  className,
  lang,
}: {
  className: string;
  lang: string;
}) {
  const [showInput, setShowInput] = useState(false);
  const [ticketId, setTicketId] = useState<string>("");
  const router = useRouter();

  return (
    <div className={cn("relative w-1/3 min-w-fit max-w-md", className)}>
      <div className="flex items-center border rounded-md bg-background">
        <Input
          name="search"
          id="searchBar"
          type="search"
          placeholder={pageTranslations.navbar.search[lang as TLanguages]}
          className="flex-1 px-4 py-2 text-xs min-w-fit focus:outline-none"
          onChange={(e) => {
            setTicketId(e.target.value);
          }}
          value={ticketId}
        />
        <Button
          variant="ghost"
          size="icon"
          className="p-2"
          onClick={() => {
            const id = ticketId;
            setTicketId("");
            if (ticketId.length > 0) router.push(`/ticket/${id}`);
          }}
        >
          <SearchIcon className="h-5 w-5 text-muted-foreground" />
        </Button>
      </div>
    </div>
  );
}
